import { createRoutine } from 'redux-saga-routines';

export const createMilestoneTemplate = createRoutine(
  'CREATE_MILESTONE_TEMPLATE'
);
export const fetchAllMilestoneTemplates = createRoutine(
  'FETCH_ALL_MILESTONE_TEMPLATES'
);
export const fetchMilestoneTemplateById = createRoutine(
  'FETCH_MILESTONE_TEMPLATE_BY_ID'
);
export const updateMilestoneTemplate = createRoutine(
  'UPDATE_MILESTONE_TEMPLATE'
);
export const archiveMilestoneTemplate = createRoutine(
  'ARCHIVE_MILESTONE_TEMPLATE'
);
export const duplicateMilestoneTemplate = createRoutine(
  'DUPLICATE_MILESTONE_TEMPLATE'
);
